import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { QUERY_RETRY, QUERY_STALE_TIME_MS } from '../constants'
import type { SanityArticle } from '../interfaces'
import { toSanityLanguage } from '../services/sanityLanguage'
import { getArticleBySlug } from '../services/sanityQueries'

interface UseResourceArticleResult {
  article: SanityArticle | null
  isLoading: boolean
  isError: boolean
}

export const useResourceArticle = (slug: string | undefined): UseResourceArticleResult => {
  const { i18n } = useTranslation()
  const language = toSanityLanguage(i18n.language)

  const { data, isLoading, isError } = useQuery(
    ['resource-center', 'article', slug, language],
    () => getArticleBySlug(slug as string, language),
    {
      enabled: Boolean(slug),
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: QUERY_RETRY,
    },
  )

  return { article: data ?? null, isLoading, isError }
}
